import React, { Component } from 'react'
import { Field as Input } from 'redux-form'

import { TextInput } from '../Inputs'


class StringInput extends Component {
  validateLength = (value) => {
    const { minLength, maxLength } = this.props.field
    const hasMinLength = !(minLength === null || minLength === undefined)
    const hasMaxLength = !(maxLength === null || maxLength === undefined)

    if (hasMinLength || hasMaxLength) {
      if (value && hasMinLength && value.length < minLength) {
        return `Debe tener al menos ${minLength} caracteres`
      } else if (value && hasMaxLength && value.length > maxLength) {
        return `Debe tener a lo más ${maxLength} caracteres`
      }
    }
  }

  checkDefaultValue = (field) => {
    if (field.enum && field.enum.length === 1){
      return { value : field.enum[0], readOnly : true }
    } else {
      return {}
    }
  }

  render() {
    const { name, disabled } = this.props.field

    return (
        <Input
          key={`ds-${name}`}
          name={name}
          inputProps={this.checkDefaultValue(this.props.field)}
          type="string"
          required={false}
          component={TextInput}
          disabled={disabled}
          validate={this.validateLength}
        />
    )
  }
}

export default StringInput
